import { render, staticRenderFns } from "./ScanditScanner.vue?vue&type=template&id=6d25e389&scoped=true"
import script from "./ScanditScanner.vue?vue&type=script&lang=js"
export * from "./ScanditScanner.vue?vue&type=script&lang=js"
import style0 from "./ScanditScanner.vue?vue&type=style&index=0&id=6d25e389&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d25e389",
  null
  
)

export default component.exports